import { CallToAction } from 'components/CallToAction'
import SliderNav from 'components/SliderNav'
import { GatsbyImage } from 'gatsby-plugin-image'
import React, { useRef, useState } from 'react'
import Slider from 'react-slick'
import { heading, section } from './classes'
import {prepareData} from 'utils/googleData'

const MarketButton = ({ title, index, activeMarket, sliderRef }) => {
    const borderColor = index === activeMarket ? 'red' : 'gray'
    const textColor = index === activeMarket ? 'red' : 'primary'
    const textColor2 = index === activeMarket ? 'red' : 'primary-dark'
    const handClick = () => {
        sliderRef.current.slickGoTo(index)
    }
    return (
        <button className={`border-b-3 border-${borderColor} text-${textColor} dark:text-${textColor2}`} onClick={handClick}>
            {title}
        </button>
    )
}

const SliderItem = ({ image, description, icon, market }) => {
    return (
        <div>
            <div className="p-6 sm:p-10 border-r border-dashed max-w-lg md:max-w-2xl lg:max-w-4xl w-full border-gray-accent-light">
                {image}
            </div>
        </div>
    )
}

export default function Markets(props) {
    const {enable,title,subtitle,description,homeMarketsTitle,cta,markets,direction,text,style,gatsbyImage,sections,gatsbyImage2}= prepareData({props})
        if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
    return <></>
  }
    const [activeMarket, setActiveMarket] = useState(0)
    const sliderRef = useRef(null)
    const sliderSettings = { dots: false, infinite: false, arrows: false, speed: 500, slidesToShow: 1, slidesToScroll: 1, autoplay: false, variableWidth: true, adaptiveHeight: true, responsive: [{ breakpoint: 639, settings: { variableWidth: false, }, },], }
    const sliderImageProps = { quality: 100, }
    const handleChange = (oldIndex, newIndex) => { setActiveMarket(newIndex) }

    return (
        <section dir={direction} className={section()}>
            <div>
                <h2 className={heading('lg', 'primary', 'max-w-[1100px] mx-auto')}>{homeMarketsTitle.title}</h2>
                <h3 className="text-lg md:text-2xl text-center md:px-8 mt-4 md:mt-8">
                    {homeMarketsTitle.subtitle}
                    <br />
                    {markets?.length > 0 && markets.map((market, index) => {
                        const { name, description, items, style = '' } = market
                        return (
                            <>
                                <MarketButton key={index} sliderRef={sliderRef} activeMarket={activeMarket} index={index} title={name} />
                                {(index == ((markets.length) - 1)) ? <> {text}  </> : <> ,{' '} </>}
                            </>
                        )
                    })}
                </h3>
            </div>
            <SliderNav
                handlePrevious={() => sliderRef.current.slickPrev()}
                handleNext={() => sliderRef.current.slickNext()}
                currentIndex={activeMarket}
                length={markets?.length}
            />
            <div className="max-w-screen-2xl mx-auto border-t border-b border-dashed border-gray-accent-light">
                <Slider beforeChange={handleChange} ref={sliderRef} {...sliderSettings}>
                    {markets?.length > 0 && markets.map((market, index) => {
                        const { name, description, gatsbyImage, style = '' } = market
                        return (
                            <>
                                <SliderItem key={index} image={<GatsbyImage {...sliderImageProps} image={gatsbyImage} />} />
                                {/* {(index==(Markets.length-1)) &&  <> & more  </>} */}
                            </>
                        )
                    })}
                </Slider>
            </div>
            <div className="px-4 text-center my-2">
                <h4 className="text-3xl font-bold mb-8"
                    dangerouslySetInnerHTML={{ __html: cta?.description }}>
                </h4>
                <CallToAction width="56" type="outline" to={cta?.title}>
                    {cta?.text}
                </CallToAction>
            </div>
        </section>
    )
}
